<svg xmlns="http://www.w3.org/2000/svg" width="48" height="48" fill="none" viewBox="0 0 48 48">
  <path fill="#000" d="M13.5 9h21v31h-21V9z"/>
  <path stroke="#000" stroke-width="2" d="M13.5 9h21v31h-21zM11 40h26"/>
  <path stroke="#fff" stroke-width="2" d="M19 16h10m-10 6h10m-10 6h10m-10 6h10"/>
</svg>
